export default __webpack_public_path__ + "3bd56026b59d5646efe59b2b031bccb2.bin";